/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PlanCheckout from "../../ui-component/zohoPlan/PlanCheckout";
import useLoggedInUserType, { USER_TYPE } from "../../hooks/useLoggedInUserType";
import IndvidualCanceCurrentSubscriptionWarn from "../../ui-component/zohoPlan/IndvidualCanceCurrentSubscriptionWarn";
import OrganisationCancelCurrentSubscriptionWarn from "../../ui-component/zohoPlan/OrganisationCancelCurrentSubscriptionWarn";
import SEO from "../../component/SEO";
import PlanList from "../../ui-component/zohoPlan/PlanList";
import useUserSubscription from "../../hooks/useUserSubscription";
// import Footer from "../../component/Footer";
import "./Plan.scss";

function Plans() {
  const [selectedPlans, setSelectedPlans] = useState(null);
  const [cancelWarningModalShow, setCancelWarningModalShow] = useState(false);
  const userType = useLoggedInUserType();
  const { subscriptionData } = useUserSubscription();
  const [relatedPlan, setRelatedPlan] = useState([]);

  const getSubscriptionData = async () => {
    try {
      if (subscriptionData?.length > 0) {
        const filterdData = subscriptionData?.filter(
          (item) => item?.relatedPlan === selectedPlans?.plan_code
        );
        if (filterdData.length > 0) {
          setCancelWarningModalShow(true);
          setRelatedPlan(filterdData);
        }
      }
    } catch (error) { }
  };
  useEffect(() => {
    if (selectedPlans !== null) {
      getSubscriptionData();
    }
  }, [selectedPlans, subscriptionData]);

  console.log(relatedPlan, subscriptionData, "relatedPlanData");
  return (

    <>
      <SEO
        title={"plans" || ''}
        description={''}
        url={''}
        ogTag={''}
        metaKeywords={''}
      />

      <div className="container">
        <div className="planpage">
          <div className="plans_right">
            <h2> Plans & Pricing </h2>
          </div>
          {USER_TYPE.INDIVIDUAL === userType &&
            relatedPlan.length &&
            cancelWarningModalShow ? (
            <IndvidualCanceCurrentSubscriptionWarn
              open={cancelWarningModalShow}
              onClose={() => setCancelWarningModalShow(false)}
            />
          ) : null}

          {USER_TYPE.ORGANIZATION === userType &&
            relatedPlan.length &&
            cancelWarningModalShow ? (
            <OrganisationCancelCurrentSubscriptionWarn
              open={cancelWarningModalShow}
              onClose={() => setCancelWarningModalShow(false)}
              planCode={selectedPlans?.plan_code}
              selectedPlans={selectedPlans}
              relatedPlan={relatedPlan}
            />
          ) : null}

          {selectedPlans && (
            <PlanCheckout
              selectedPlans={selectedPlans}
              setSelectedPlans={setSelectedPlans}
            />
          )}
          {selectedPlans === null && (
            <PlanList setSelectedPlans={setSelectedPlans} />
          )}
          {/* <PlanList /> */}
          {/* <ZohoPlanList /> */}
        </div>
      </div>
      {/* <Footer />  */}
    </>

  );
};

export default Plans;
